module.exports = __webpack_public_path__ + "fonts/NimbusMonoL-Bold.112fe7bf.woff";